/**
 * @module alpha-mixin/ui-state
 * @mixin
 * @type {{}}
 */
function UIState(){
    this.before('_mergeInheritedAttrs', initUIStateAttrs);
    this.after('initialize', initDomEventListeners);
}


/**
 * 组件`attrs`增加 ui-state 相关配置
 */
function initUIStateAttrs() {
    var attrs = this.attrs;

    attrs.disabled = {
        value: null,
        setter: function(val){
            if(typeof val != 'boolean') {
                throw new Error('attrs.disabled must be an boolean!');
            }
            return val;
        }
    };
    attrs.focused = {
        value: null,
        setter: function(val){
            if(typeof val != 'boolean') {
                throw new Error('attrs.focused must be an boolean!');
            }
            var prev = this.get('focused');
            var disabled = this.get('disabled');
            return disabled? prev: val;
        }
    };
    attrs.visible = {
        value: null,
        setter: function(val){
            if(typeof val != 'boolean') {
                throw new Error('attrs.visible must be an boolean!');
            }
            return val;
        }
    };
}

/**
 * disabled 属性改变回调函数
 */
UIState.prototype._onRenderDisabled = function(val, prev, key){
    this.element.toggleClass('disabled', val);
    this.element.attr('aria-disabled', val);
};

/**
 * visible 属性改变回调函数
 */
UIState.prototype._onRenderVisible = function(val, prev, key){
    this.element.attr('aria-hidden', !val);
    this.element.toggle(val);
};

/**
 * focused 属性改变回调函数
 */
UIState.prototype._onRenderFocused = function(val, prev, key){
    this.element.toggleClass('focused', val);

    var focusNode;
    if (this.focusNode.length) {
        focusNode = this.focusNode;
    } else {
        focusNode = this.element;
    }
    if (!this._oldTabIndex) {
        this._oldTabIndex = focusNode.attr('tabindex');
    }

    if (val) {
        try {
            focusNode.attr('tabindex', 0);
            focusNode.focus();
        } catch (e) {

        }
    } else {
        try {
            if (this._oldTabIndex != null) {
                focusNode.attr('tabindex', this._oldTabIndex);
            } else {
                focusNode.removeAttr('tabindex');
            }
            focusNode.blur();
        } catch (e) {
        }
    }
};

UIState.prototype.blur = function(){
    this.set('focused', false);
};

UIState.prototype.focus = function(){
    this.set('focused', true);
};



/**
 * dom[focus] 事件处理
 */
function initDomEventListeners() {
    var focusNode = this.focusNode;
    if(focusNode){
        this.delegateEvents(focusNode, 'focus.uistate.mixin', function(){
            var disabled = this.get('disabled');
            if(!disabled) {
                this.focus();
            }
        });
        this.delegateEvents(focusNode, 'blur.uistate.mixin', function(){
            this.blur();
        });
    }
}



module.exports = UIState;